import React from 'react';
import classNames from 'classnames';
import { OverflowMenu, OverflowMenuItem, Button, Link as CarbonLink } from 'carbon-components-react';
import { Link } from 'react-router-dom';
import { history } from '../../services/ReduxStore';
import { map } from 'lodash';
import { t } from 'i18next';
import { BrandLogo } from '../BrandLogo';
import { UserMenu } from '../UserMenu';
import { Icomoon } from '../Icomoon';
import { MainMenu, MainMenuItem } from '../MainMenu';
import { Notifications } from '../Notifications';
import { AppMenu } from '../../containers/App/AppMenu.js';

class TopNav extends React.Component {
	static defaultProps = {
		user: {},
		doLogout: () => void 0,
		doSearch: () => void 0,
		onClearUnread: () => void 0,
		searchTerm: ''
	};

	constructor(props) {
		super(props);

		this.state = {
			content: 'menu',
			isOpen: false,
			screenWidth: document.documentElement.clientWidth
		};
	}

	componentDidMount() {
		window.addEventListener('resize', this.resetMenus);
	}

	componentWillMount() {
		this.unlisten = history.listen(() => {this.toggleMenu()});
	}

	componentWillUnmount() {
		this.unlisten();
		window.removeEventListener('resize', this.resetMenus);
	}

	resetMenus = () => {
		// If screen width has changed, auto-close the menu and reset body overflow
		if (this.state.screenWidth !== document.documentElement.clientWidth) {
			this.setState({
				isOpen: false,
				screenWidth: document.documentElement.clientWidth
			});
			document.body.style.overflow = 'auto';
			document.body.style.position = 'relative';
			window.scrollTo(0, document.body.dataset.dataPos);
		}
	}

	toggleMenu = (e) => {
		if (!this.state.isOpen && e) {
			// If its not open, open it with the correct content
			this.setState({
				content: e,
				isOpen: true,
			});

			//Log scroll position and set a data attr to hold onto it.
			document.body.dataset.dataPos = window.pageYOffset;
			setTimeout(function() {
				document.body.style.overflow = 'hidden';
				document.body.style.position = 'fixed';
			}, 400);
		} else if (this.state.isOpen && e && (e !== this.state.content)) {
			// if its open but different content is chosen
			this.setState({
				content: e,
			});
		} else {
			//Go back to previous scroll position
			document.body.style.overflow = 'auto';
			document.body.style.position = 'relative';
			window.scrollTo(0, document.body.dataset.dataPos);

			// Close Menu
			this.setState({
				isOpen: false,
			});
		}
	};

	render() {
		const mobileToggleMainClass = classNames({
			'tbk--nav--mobile__button--active': (this.state.isOpen && this.state.content === 'main'),
		});

		const mobileToggleNotificationsClass = classNames({
			'tbk--nav--mobile__button--active': (this.state.isOpen && this.state.content === 'notifications'),
		});

		const mobileMenuClasses = classNames({
			'tbk--nav--mobile__menu': true,
			'tbk--nav--mobile__menu--open': this.state.isOpen,
			'tbk--nav--mobile__menu--main': this.state.content === 'main',
			'tbk--nav--mobile__menu--notifications': this.state.content === 'notifications',
		});

		const assets = this.props.assets;
		const footerLinks = assets.footerLinks || [];
		const supportLinks = assets.supportLinks || [];
		const additionalLinks = footerLinks.concat( supportLinks );
		const pages = assets.pages || {};
		const logo_navbar = assets.logo_navbar || null;
		const logo_mobile = assets.logo_mobile || null;

		const dashboard = (this.props.user.wpDashboard) ?
			<li className="bx--overflow-menu-options__option" role="menuitem">
				<a className="bx--link bx--overflow-menu-options__btn" href={this.props.user.wpDashboard} target="_blank">
					{t('Dashboard')}
				</a>
			</li> : null;

		return ([
			<div key="top-nav" className="tbk--nav--top">
				<div className="tbk--nav--top__inner">
					<div className="tbk--nav--top__logo">
						<BrandLogo placement="top-nav" link="/">
							{logo_navbar &&
								<img src={logo_navbar} alt="Renin"/>
							}
						</BrandLogo>
					</div>
					{this.props.searchElement}
					<div className="tbk--nav--top__notification">
						<OverflowMenu
							className="tbk--nav--top__overflow-menu"
							iconDescription="View your notifications"
							renderIcon={iconProps => <div {...iconProps}><Notifications kind="badge" counts={this.props.user.counts} /></div>}
							ariaLabel={t('Notifications')}
						>
							<Notifications kind="full" counts={this.props.user.counts} onClearUnread={this.props.onClearUnread} />
						</OverflowMenu>
					</div>
					<div className="tbk--nav--top__user">
						<OverflowMenu
							className="tbk--nav--top__overflow-menu"
							iconDescription={t('User Profile Options')}
							renderIcon={iconProps => <div {...iconProps}><UserMenu kind="dropdown" user={this.props.user}/></div>}
							ariaLabel={t('User menu')}
						>
							<UserMenu key="usermenu" kind="navbar" user={this.props.user} />
							{dashboard}
							<li className="bx--overflow-menu-options__option" role="menuitem">
								<CarbonLink className="bx--overflow-menu-options__btn" href="https://www.renin.com/" target="_blank">{t('Back to Renin.com')}</CarbonLink>
							</li>
							{map(additionalLinks, pageID =>
								<li key={'additional-link-' + pageID} className="bx--overflow-menu-options__option" role="menuitem">
									<Link className="bx--link bx--overflow-menu-options__btn" to={pages[pageID].path}>
										{pages[pageID].title}
									</Link>
								</li>
							)}
							<OverflowMenuItem hasDivider isDelete key="logout" itemText={t('Log Out')} onClick={this.props.doLogout}/>
						</OverflowMenu>
					</div>
				</div>
			</div>,

			<div key="top-nav-mobile" className="tbk--nav--top__mobile">
				<div className="tbk--nav--top__inner">
					{this.props.searchElement}
				</div>
			</div>,

			<div key="mobile-nav" className="tbk--nav--mobile">
				<div className="tbk--nav--mobile__inner">
					<div className="tbk--nav--mobile__button">
						<Button kind="ghost" onClick={() => this.toggleMenu('notifications')} className={mobileToggleNotificationsClass}>
							<span className="tbk--nav--mobile__button-inner">
								<Notifications kind="badge" counts={this.props.user.counts} />
								<div className="tbk--nav--mobile__button-text">{t('Alerts')}</div>
							</span>
						</Button>
					</div>
					<div className="tbk--nav--mobile__logo">
						<BrandLogo title="Renin" placement="mobile-nav" link="/" tabIndex="4">
							{logo_mobile &&
								<img src={logo_mobile} alt="Renin"/>
							}
						</BrandLogo>
					</div>
					<div className="tbk--nav--mobile__button">
						<Button kind="ghost" onClick={() => this.toggleMenu('main')} className={mobileToggleMainClass}>
							<span className="tbk--nav--mobile__button-inner">
								<Icomoon icon="menu"/>
								<div className="tbk--nav--mobile__button-text">{t('Menu')}</div>
							</span>
						</Button>
					</div>
					<div className={mobileMenuClasses}>
						<div className="tbk--nav--mobile__canvas tbk--nav--mobile__canvas--notifications">
							<Notifications kind="full" counts={this.props.user.counts} onClearUnread={this.props.onClearUnread} />
						</div>
						<div className="tbk--nav--mobile__canvas tbk--nav--mobile__canvas--notifications">
							<Notifications kind="full" counts={this.props.user.counts} onClearUnread={this.props.onClearUnread} />
						</div>
						<div className="tbk--nav--mobile__canvas tbk--nav--mobile__canvas--main">
							<AppMenu categories={this.props.assets.categories} />
							{additionalLinks.length > 0 &&
								<MainMenu aria-label={t('Additional Links')}>
									<MainMenuItem title={t('Additional Links')}>
										{map(additionalLinks, pageID =>
											<MainMenuItem key={pageID} href={pages[pageID].path} title={pages[pageID].title}/>
										)}
									</MainMenuItem>
								</MainMenu>
							}
							<MainMenu aria-label={t('User Menu')}>
								<MainMenuItem icon="user" title={t('Edit Profile')} href="edit-profile" className="tbk--main-menu-item--edit-profile"/>
								<li className="tbk--main-menu-item tbk--main-menu-item--renin" role="none">
									<a className="tbk--main-menu-item__link" role="menuitem" href="https://www.renin.com/" rel="noopener noreferrer" target="_blank">
										<Icomoon icon="digital-advertising" className="tbk--main-menu-item__icon" />
										<div className="tbk--main-menu-item__title">{t('Back to Renin.com')}</div>
									</a>
								</li>
								<MainMenuItem icon="exit" title={t('Log Out')} href="#" onClick={this.props.doLogout} className="tbk--main-menu-item--logout"/>
							</MainMenu>
						</div>
					</div>
				</div>
			</div>
		])
	}
}

export { TopNav };



// WEBPACK FOOTER //
// ./src/components/TopNav/TopNav.js